import React from 'react';
import '../../less/payment-notice.less';
import '../../less/payment-notice-mobile.less';
import pay1 from '../../../../img/pay.svg';
import pay2 from '../../../../img/pay_2.svg';
import image from '../../img/left_img.png';

export default function template() {
    return (
        <div className="module-payment-notice-container">
            <div className="module-content-wrapper">
                <p className="main-title">{this.l10n('GOOGLE_PAY_PAYMENT_CARD')}</p>

                <div className="main-payment-notice-content">
                    <div className="left-side">
                        <p>{this.l10n('GOOGLE_PAY_PAYMENT_CARD_TEXT_1')}</p>
                    </div>
                    <div className="right-side">
                        <div className="slider-container">
                            <img src={image} />
                        </div>
                        <p className="info">{this.l10n('GOOGLE_PAY_PAYMENT_NOTICE')}</p>
                        <div className="sign-wrapper">
                            <div>
                                <img src={pay1} alt="" />
                                <img src={pay2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
